<template>
    <div>
      <div v-if="loading">
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h3>VER PROGRAMA DE RETIRO</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9">
              <p class="text-semibold">Fecha: {{ programa_retiro.fecha | fecha }}</p>
            </div>
            <div class="col-md-2">
              <button @click="copiar" class="btn-copy">Copiar programa</button>
            </div>
            <div class="col-md-1">
              <button @click="volver" class="return">Volver</button>
            </div>
          </div>
          <div>
            <table>
      <thead style="">
        <tr>
          <th>PRODUCTO</th>
          <th>CANTIDAD (KG)</th>
          <th>RECIBIDO (KG)</th>
          <th>PENDIENTE (KG)</th>
        </tr>
      </thead>
      <tbody style="background-color:#fff">
        
        <tr v-for="item in resumen" :key="item.id">
          <td>{{item.nombre}}</td>
          <td class="align-right">{{ item.total | formatear_miles }}</td>
          <td class="align-right">{{ item.recibido | formatear_miles }}</td>
          <td class="align-right">{{ item.pendiente | formatear_miles }}</td>
        </tr>
      </tbody>
    </table>
          </div>
          <div class="row mt-3 pr-table-container">
            <table class="table table-bordered">
              <tr class="background-columnas">
                <th class="label-columnas th" v-for="columna in columnas_pr">
                  {{ columna.text }}
                </th>
              </tr>
              <tr v-for="(item, i) in programa_retiro.detalle">
                <td class="td" v-for="columna in columnas_pr">
                  <template v-if="columna.value === 'finalizado'">
                    <span v-if="item[columna.value] === 1">Finalizado</span>
                    <span v-else>Pendiente</span>
                    <!--<i v-if="item[columna.value] === 1" class="fas fa-check icon-green"></i>
                    <i v-else class="fas fa-exclamation-circle icon-red"></i>-->
                  </template>
                  <template v-else-if="columna.type === 'datetime'">
                    {{ item[columna.value] | fecha_hora }}
                  </template>
                  <template v-else>
                    <span class="table-text">
                      {{ item[columna.value] }}
                    </span>
                  </template>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div id="swal-container"></div>
    </div>
  </template>
  <style scoped>
  th,td{
    border:1px solid #3c3c3c;
  padding:2px 5px;
  }
  th{
    background-color:#f4a261;color:#000
  }
  .align-right{
    text-align:right;
  }
</style>
  
  <script>
  import { mapState } from "vuex";
  
  export default {
    data() {
      return {
        loading: true,
        programa_retiro: {
          fecha: "",
          detalle: []
        },
        validationErrors: {},
        listas: {
          pr_plantas: [],
          pr_proveedores: [],
          pr_tipo_estanque: [],
          pr_productos: [],
          pr_especies: [],
          transportes: [],
          procedencias: []
        },
        resumen:[],
        columnas_pr: [
          { text: "Planta", value: "planta" },
          { text: "Procedencia", value: "procedencia" },
          { text: "Proveedor", value: "proveedor" },
          { text: "Fecha retiro", value: "fecha_hora_retiro", type: "datetime" },
          { text: "Camión", value: "camion" },
          { text: "Tipo estanque", value: "estanque" },
          { text: "Horas", value: "horas" },
          { text: "ETA", value: "fecha_hora_llegada", type: "datetime" },
          { text: "KG Est.", value: "kg_estimados" },
          { text: "Productos", value: "pr_productos_id" },
          { text: "Especies", value: "especie" },
          { text: "Carga Bins", value: "carga_bins" },
          { text: "Motivo", value: "motivo" },
          { text: "Finalizado", value: "finalizado" },
        ]
      };
    },
  
    async mounted() {
      if (this.$route.params.id) {
        const programa = await this.cargarPrograma(this.$route.params.id);
        if (!programa.data) {
          this.$router.push("/programa_retiro/listado");
        } else {
          this.programa_retiro = programa.data;
          this.resumen = programa.resumen
        }
      }
      this.loading = false;
    },
  
    methods: {
  
      cargarPrograma(id) {
        const url = `${this.api}/programa_retiro/${id}?with_relations=1`;
        return this.axios
          .get(url, this.cabeceras_json)
          .then(res => {
            return res.data.data;
          })
          .catch(e => {
            console.log(e);
            return null;
          });
      },
      
      volver() {
        this.$router.push("/programa_retiro/listado");
      },

      copiar() {
        this.$router.push({name: 'programa_retiro_generar', params: {id_copia: this.programa_retiro.id}});
      }
    },
    computed: {
      ...mapState(["api", "api_public", "cabeceras_json", "token"]),
      isEditing() {
        return this.$route.params.id;
      }
    }
  };
</script>
  
<style scoped>
  .pr-table-container {
    overflow: auto;
  }
  .background-columnas {
    color: #fff;
    background-color: #468faf;
  }
  
  .label-columnas {
    font-family: inherit;
    font-size: 0.7rem;
    letter-spacing: 1px;
    font-weight: 550;
  }

  .return {
    font-family: inherit;
    color: #fff;
    border-color: #5e72e4;
    background-color: #5e72e4;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    border-radius: 3px;
    border: 1px solid transparent;
    letter-spacing: 0.025em;
    text-transform: none;
    font-size: 0.8rem;
    font-weight: 550;
    padding: 0.625rem 1.25rem;
  }
  
  .return:focus {
    outline: none;
  }
  
  .return {
    transition: transform 0.2s ease-in-out;
  }
  
  .return:hover {
    transform: translateY(-1px); /* Mueve -1px hacia arriba */
  }

  .spinner-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spinner {
    display: inline-block;
    width: 70px;
    height: 70px;
    border: 8px solid #fff;
    border-radius: 50%;
    border-top-color: #5e72e4;
    animation: rotate 1s linear infinite;
  }
  
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  .icon-green {
    color: rgb(12, 206, 107);
    font-size: 1.1rem;
  }

  .icon-red {
    color: rgb(255, 60, 0);
    font-size: 1.1rem;
  }

  .th, .td {
    padding: 0.9rem;
  }

  .td {
    text-align: center;
  }

  .text-semibold {
    font-weight: 600;
  }

  .table-text {
    display: block;
    white-space: normal;
    width: max-content;
    max-width: 250px;
    text-align: left;
  }

  .btn-copy {
    font-family: inherit;
    color: #fff;
    border-color: #505056;
    background-color: #9497a9;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    border-radius: 3px;
    border: 1px solid transparent;
    letter-spacing: 0.025em;
    text-transform: none;
    font-size: 0.8rem;
    font-weight: 550;
    padding: 0.625rem 1.25rem;
  }
  
  .btn-copy:focus {
    outline: none;
  }
  
  .btn-copy {
    transition: transform 0.2s ease-in-out;
  }
  
  .btn-copy:hover {
    transform: translateY(-1px); /* Mueve -1px hacia arriba */
  }
</style>
  